import { render } from "./App.vue?vue&type=template&id=8792a3cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8792a3cc&lang=css"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__